import { Dispatch, SetStateAction } from "react";
import Switch from "@/app/_components/inputs/switch";
import MobileStackedProgressBar from "./_components/mobile-stacked-progress-bar";
import { BarChartOptions } from "@/app/types/types";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type OverViewProps = {
  loading: boolean;
  overviewRange: "MTD" | "WTD" | "YTD";
  dealStatusOptions: BarChartOptions;
  saleTypeOptions: BarChartOptions;
  unitsByPaymentTypeOptions: BarChartOptions;
  setGtgEnabled: Dispatch<SetStateAction<boolean>>;
  gtgEnabled: boolean;
};

export default function Overview({
  loading,
  setGtgEnabled,
  gtgEnabled,
  overviewRange,
  dealStatusOptions,
  saleTypeOptions,
  unitsByPaymentTypeOptions,
}: OverViewProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-semibold">Overview</CardTitle>
          <Switch
            enabled={gtgEnabled}
            handleChange={() => setGtgEnabled(!gtgEnabled)}
            label="GTG"
          />
        </div>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <MobileStackedProgressBar
          loading={loading}
          title="Sale Status"
          gtgEnabled={gtgEnabled}
          selected={overviewRange}
          options={dealStatusOptions}
          tooltip={(option) =>
            `${option.key.toLowerCase().replace("_", " ")}: ${option.amount} ${
              option.amount === 1 ? "Unit" : "Units"
            } (${option.percentage.toFixed(2)}%)`
          }
        />
        <MobileStackedProgressBar
          loading={loading}
          gtgEnabled={gtgEnabled}
          selected={overviewRange}
          title="Sale Type"
          options={saleTypeOptions}
          tooltip={(option) =>
            `${option.key === "DLA" ? option.key : option.key.toLowerCase()}: ${
              option.amount
            } ${option.amount === 1 ? "Unit" : "Units"} (${option.percentage.toFixed(2)}%)`
          }
        />
        <MobileStackedProgressBar
          loading={loading}
          gtgEnabled={gtgEnabled}
          selected={overviewRange}
          title="Deal Type"
          options={unitsByPaymentTypeOptions}
          tooltip={(option) =>
            `${option.key.toLowerCase()}: ${option.amount} ${
              option.amount === 1 ? "Unit" : "Units"
            } (${option.percentage.toFixed(2)}%)`
          }
        />
      </CardContent>
    </Card>
  );
}
